<template>
  <b-form-group :label="label">
    <v-select
      :name="name"
      :value="optionSelected"
      :options="paginatedValues"
      :class="{ 'v-select-danger': danger, 'select-size-sm': small }"
      :disabled="isDisabled"
      :filterable="false"
      :clearable="isClearable"
      :placeholder="placeholder"
      :multiple="isMultiple"
      @search="onSearch"
      @input="onInput"
      @search:focus="onFocus"
    >
      <template #spinner>
        <b-spinner
          small
          v-if="profilesState.loading"
          :style="{ opacity: profilesState.loading ? 1 : 0 }"
          variant="primary"
        />
      </template>
      <template v-slot:option="{value, label, iut}">
        <span
          :data-cy-iut="iut"
          :data-cy-value="value"
          :data-cy-label="label"
        >
          {{ label }}
        </span>
      </template>
      <template slot="no-options">
        escribe para buscar perfiles..
      </template>
      <li
        v-if="hasNextPage"
        slot="list-footer"
        class="pagination"
      >
        <button
          class="btn btn-block btn-primary btn-sm"
          type="button"
          @click="searchPage"
          :disabled="!hasNextPage"
        >
          buscar más perfiles...
        </button>
      </li>
    </v-select>
    <div v-if="withFilters" class="d-flex mt-1">
    </div>
    <div v-if="danger" class="con-text-validation span-text-validation-danger v-enter-to">
      <span class="span-text-validation">{{ dangerText }}</span>
    </div>
  </b-form-group>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  data() {
    return {
      query: '',
      limit: 10,
      page: 1,
      pages: 1,
      filterBy: 'label'
    };
  },
  computed: {
    ...mapGetters('Empresas', ['companyId', 'company']),
    profilesState() {
      const indexedBy = [this.companyId].filter(Boolean).join('-') || 'value';
      const index = this.$store.state.List.profiles[indexedBy] || {};
      const profiles = Object.values(index);

      return {
        value: profiles.sort((a, b) => a.label.localeCompare(b.label)),
        loading: this.$store.state.List.profiles.loading
      };
    },
    isDisabled() { return this.disabled; },
    optionSelected() {
      return this.profilesState.value.find((option) => option.value === this.value);
    },
    hasNextPage() {
      return this.page < Math.max(this.pages, this.filteredPages);
    },
    filteredValues() {
      const toFilter = this.filterBy;
      let options = this.profilesState.value.filter((val) => new RegExp(`.*${this.query}.*`, 'i').test(val[toFilter]));
      if (this.showOptionAll) {
        options = [{ value: '*', label: 'Todos' }, ...options];
      }
      return options;
    },
    paginatedValues() {
      return this.filteredValues.slice(0, this.limit * this.page);
    },
    filteredPages() {
      return this.filteredValues.length / this.limit;
    }
  },
  methods: {
    ...mapActions('List', ['fetchProfiles']),
    onInput(event) {
      this.$emit('full-profile', event);
      this.$emit('input', event?.value);
    },
    onFocus() {
      this.page = 1;
      this.query = '';
      this.debounceFetchProfiles();
    },
    searchPage() {
      this.debounceFetchProfiles({ page: this.page += 1, query: this.query });
    },
    onSearch(query) {
      if (!query) return;
      this.pages = 1;
      this.query = query;
      this.debounceFetchProfiles({ query });
    },
    debounceFetchProfiles: _.debounce(async function (payload = {}) {
      await this.fetchProfiles(payload);
    }, 350),
  },
  props: {
    name: { type: String, required: true },
    withFilters: { type: Boolean, default: false },
    placeholder: String,
    label: { type: String, default: 'Perfiles' },
    value: { type: String | Array },
    required: { type: Boolean, default: false },
    danger: { type: Boolean },
    dangerText: { type: String },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    small: { type: Boolean, default: false },
    isClearable: { type: Boolean, default: true },
    isMultiple: { type: Boolean, default: false },
    showOptionAll: { type: Boolean, default: false }
  }
};
</script>
